import propTypes from 'prop-types';

export const SubstitutionRange = ({ range }) => {
  const rangeUrl = range.rangeUrl;

  return (
    <a className="subst-range" href={rangeUrl}>
      <img className="subst-range__image" src={range.pictureUrl} alt={range.displayName} />
      <div className="subst-range__content">
        <p className="subst-range__title">{range.displayName}</p>
        <p className="subst-range__desc">{range.description}</p>
        <p className="subst-range__desc-long">{range.longDescription}</p>
      </div>
    </a>
  );
};

SubstitutionRange.propTypes = {
  range: propTypes.shape({
    rangeUrl: propTypes.string.isRequired,
    pictureUrl: propTypes.string.isRequired,
    displayName: propTypes.string.isRequired,
    description: propTypes.string.isRequired,
    longDescription: propTypes.string.isRequired
  })
};
